import { SquirtleSquadApiClient } from '@madbox/squirtle_squad_api_client';

const MemberManager = {
  // Param : { withOrganizations? : boolean, withApplications? : boolean, withTeams? : boolean}
  get: (optionsWith) => {
    return SquirtleSquadApiClient.instance.Member.get(optionsWith);
  },
  forgotPassword: (mail) => {
    return SquirtleSquadApiClient.instance.Member.forgotPassword(mail);
  },
  updateProfile: (mail, firstname, lastname, profilePicture, spokenLanguages) => {
    return SquirtleSquadApiClient.instance.Member.update(mail, firstname, lastname, profilePicture, spokenLanguages);
  },
  updatePassword: (oldPassword, newPassword) => {
    return SquirtleSquadApiClient.instance.Member.updatePassword(oldPassword, newPassword);
  },
  disableAccount: (memberId, isDisabled) => {
    return SquirtleSquadApiClient.instance.Member.disableAccount(memberId, isDisabled);
  },
  Organization: {
    getAll: (memberId) => {
      return SquirtleSquadApiClient.instance.Member.Organization.getAll(memberId);
    },
  },
  Application: {
    getAll: (orgSlug) => {
      return SquirtleSquadApiClient.instance.Member.getApplications(orgSlug);
    },
  },
};

export default MemberManager;
